import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsStore } from '@app/core/state/app-settings-store/app-settings-store';
import { DocRegDetailsDeleteDTO } from '@modules/registered-document-manager/models';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentContentSearchDeleteService {
    private apiUrl = environment.apiRoot;

    constructor(
        private http: HttpClient,
        private appSettingsStore: AppSettingsStore
    ) {}

    /**
     * DELETE /api/documents/{id}
     */
    deleteDetail(dto: DocRegDetailsDeleteDTO): Observable<any> {
        const headers = new HttpHeaders()
            .set('X-ClientId', this.appSettingsStore.settings()?.user?.id || '')
            .set('X-User',     this.appSettingsStore.settings()?.user?.name || '');

        return this.http.delete<any>(
            `${this.apiUrl}documents/${dto.id}`,
            { headers }
        );
    }

    getDocumentContentSearchDelete$(): Observable<{}> {
        return of({});
    }
}
